import React from 'react'
import { useTranslation } from 'react-i18next'
import ResponsiveBreakpointsRolloutBoundary from 'components/ResponsiveBreakpointsRolloutBoundary'
import { RESPONSIVE_BREAKPOINT_PAGES } from 'constants/responsiveBreakpoints'
import { SettingsAndPreferences } from './SettingsAndPreferences'

export const SettingsAndPreferencesWithRollout = () => {
  const { t } = useTranslation()

  return (
    <ResponsiveBreakpointsRolloutBoundary
      fallback={
        <div aria-live="polite" role="status">
          {t('general.loading')}
        </div>
      }
      page={RESPONSIVE_BREAKPOINT_PAGES.SETTINGS_PREFERENCES}
    >
      <SettingsAndPreferences />
    </ResponsiveBreakpointsRolloutBoundary>
  )
}

export default SettingsAndPreferencesWithRollout
